import React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import ChartContainer from './ChartContainer';
import { chartConfig } from '../styles/ChartStyles';

const HistoricalChart = ({ propertyData }) => {
  if (!propertyData || propertyData.status !== 'success' || !propertyData.data) {
    return null;
  }

  const data = propertyData.data;
  const hasRealHistory = data.valueHistory && data.valueHistory.length > 0;

  const renderChart = () => {
    if (hasRealHistory) {
      return (
        <LineChart
          series={[
            {
              data: data.valueHistory.map(point => point.value),
              label: 'Property Value',
              area: true,
              showMark: false,
              color: '#4f46e5',
            }
          ]}
          xAxis={[{
            data: data.valueHistory.map(point => new Date(point.date).getTime()),
            scaleType: 'time',
            valueFormatter: (value) => {
              const date = new Date(value);
              return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
            },
          }]}
          yAxis={[{
            valueFormatter: (value) => `$${value.toLocaleString()}`,
          }]}
          {...chartConfig}
        />
      );
    }

    // Simulated data
    const simulatedValues = [
      data.estimatedValue * 0.7,
      data.estimatedValue * 0.8,
      data.estimatedValue * 0.9,
      data.estimatedValue * 0.95,
      data.estimatedValue,
      data.estimatedValue * 1.1,
      data.estimatedValue * 1.2
    ];

    const simulatedDates = [
      new Date('2017-01-01').getTime(),
      new Date('2018-01-01').getTime(),
      new Date('2019-01-01').getTime(),
      new Date('2020-01-01').getTime(),
      new Date('2021-01-01').getTime(),
      new Date('2022-01-01').getTime(),
      new Date('2023-01-01').getTime(),
    ];

    return (
      <LineChart
        series={[
          {
            data: simulatedValues,
            label: 'Estimated Value Trend',
            area: true,
            showMark: false,
            color: '#4f46e5',
          }
        ]}
        xAxis={[{
          data: simulatedDates,
          scaleType: 'time',
          valueFormatter: (value) => {
            const date = new Date(value);
            return date.getFullYear().toString();
          },
        }]}
        yAxis={[{
          valueFormatter: (value) => `$${value.toLocaleString()}`,
        }]}
        {...chartConfig}
      />
    );
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
      <div className="p-5">
        <div className="flex items-center mb-4">
          <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center mr-3">
            <svg className="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
            </svg>
          </div>
          <h4 className="text-lg font-semibold text-gray-900">Value History (10 Years)</h4>
        </div>
        
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-2">
          <ChartContainer>
            {renderChart()}
          </ChartContainer>
          <div className="text-xs text-center text-gray-600 mt-2 font-medium p-2">
            {hasRealHistory
              ? `Real historical data (${data.valueHistory.length} months)`
              : 'Estimated value trend (simulated)'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoricalChart;